const shimmer = "relative overflow-hidden before:absolute before:inset-0 before:-translate-x-full before:animate-[shimmer_1.5s_infinite] before:bg-gradient-to-r before:from-transparent before:via-white/5 before:to-transparent";
const reduced = "@media (prefers-reduced-motion: reduce) { .skel-shimmer::before { animation: none !important; } }";

export function SkeletonText({ width = "w-2/3", height = "h-3", className = "" }) {
  return (
    <>
      <div className={`rounded ${width} ${height} bg-white/5 skel-shimmer ${shimmer} ${className}`} />
      <style>{reduced}</style>
    </>
  );
}

export function SkeletonCircle({ size = "h-8 w-8", className = "" }) {
  return (
    <>
      <div className={`rounded-full ${size} bg-white/5 skel-shimmer ${shimmer} ${className}`} />
      <style>{reduced}</style>
    </>
  );
}

export function SkeletonCard({ className = "" }) {
  return (
    <div className={`rounded-xl border border-white/5 p-4 space-y-3 bg-white/[0.02] ${className}`}>
      <SkeletonText width="w-1/3" height="h-4" />
      <SkeletonText width="w-full" />
      <SkeletonText width="w-4/5" />
    </div>
  );
}

export function SkeletonRow({ className = "" }) {
  return (
    <div className={`flex items-center gap-3 px-3 py-2.5 ${className}`}>
      <SkeletonCircle size="h-6 w-6" />
      <div className="flex-1 space-y-1.5">
        <SkeletonText width="w-3/5" height="h-3.5" />
        <SkeletonText width="w-2/5" height="h-2.5" />
      </div>
    </div>
  );
}

export function PageSkeleton() {
  return (
    <div className="min-h-screen flex" style={{ background: "#0A0A0F" }}>
      <div className="w-14 shrink-0 border-r border-white/5 hidden md:block" />
      <div className="flex-1 p-6 space-y-6 max-w-6xl mx-auto">
        <div className="flex items-center gap-4 mb-8">
          <SkeletonText width="w-48" height="h-6" />
          <div className="ml-auto flex gap-2">
            <SkeletonCircle size="h-8 w-8" />
            <SkeletonCircle size="h-8 w-8" />
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <SkeletonCard />
          <SkeletonCard />
          <SkeletonCard />
        </div>
        <div className="space-y-2">
          {[1, 2, 3, 4, 5].map(i => <SkeletonRow key={i} />)}
        </div>
      </div>
    </div>
  );
}
